import React, { useEffect, useState, useRef } from 'react'
import { Box, Container, Typography, Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import TextareaAutosize from 'react-textarea-autosize';
import localforage from 'localforage'
import { nanoid } from 'nanoid';

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  getChunks,
  setOnChatChunkHandler,
  lastMessageIdState,
  getSendMessage,
  accountState,
  configsState,
  activeChatState,
  latestChatState,
  typingState,
  chunksState,
} from '../state'

import FastRegister from '../components/FastRegister'
import StaticConfig from '../components/StaticConfig'
import Download from '../components/Download'
import SubscriptionDays from '../components/SubscriptionDays';

export function App() {
  const account = useRecoilValue(accountState)

  useEffect(() => {
    const run = async () => {
      if (account) {
        console.log('account', account)
        try {
          // const opened = await openDB(`app-${account.id}`, 1)
          // await initDB(account.id)
        } catch (err) {
          console.log('openDB error', err)
        }
      } else {
        console.log('account not found', account)
      }
    }
    run()
  }, [account])

  return (
    <>
      <Box sx={{
        height: '76vh',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        // backdropFilter: 'blur(5px)',
        // backgroundImage: `url(${mapImage})`,
        // backgroundSize: 'contain',
        // backgroundPosition: 'center',
        // backgroundRepeat: 'no-repeat',
        p: { xs: 0, md: 2, lg: 3 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',

      }}>
        <ConfWrapper />

        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          flex: '1 1 40%',
          // height: '100%',
          minWidth: { xs: '12rem', md: '20rem', lg: '20rem' },
          // mt: 8,
        }}>
          <Download />
        </Box>
      </Box>
    </>
  )
}

function ConfWrapper() {
  const account = useRecoilValue(accountState)

  if (!account) return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flex: '1 1 30%',
      minWidth: { xs: '12rem', md: '20rem', lg: '20rem' },
    }}>
      <Typography
        variant="h6"
        color="text.primary"
        sx={{
          mt: 2,
          mb: 1,
          // pr: 0.5,
          display: 'inline-block',
          // borderBottom: '1px solid',
          borderColor: 'text.primary',
        }}
      >
        Create or login your WireDefense Account
      </Typography>
      <FastRegister />
    </Box>)

  return (<Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    flex: '1 1 60%',
    // height: '100%',
    minWidth: { xs: '12rem', md: '20rem', lg: '20rem' },
    gap: 2,
  }}>

    <Typography variant="h5" sx={{
      my: 1,
      textAlign: 'center'
    }}>
      Wireguard Configs
    </Typography>

    <SubscriptionDays />

    <StaticConfig />
  </Box>)
}


export default App